import React from 'react';

import {
  ShippingInfoStyled,
  ShippingItem,
  PackingItem,
  Title,
  ShippingBlock,
} from './styledComponents';

const ShippingInfo = ({ shipping, poNumber }) => {
  const { address, packingInstructions } = shipping;

  return (
    <ShippingInfoStyled>
      <ShippingBlock>
        <Title>Shipping</Title>
        <ShippingItem>
          <span>Address1:</span>
          <span>{address.address1}</span>
        </ShippingItem>
        <ShippingItem>
          <span>Address2:</span>
          <span>{address.address2}</span>
        </ShippingItem>
        <ShippingItem>
          <span>City:</span>
          <span>{address.city}</span>
        </ShippingItem>
        <ShippingItem>
          <span>State/Province/Region:</span>
          <span>{address.state || address.province}</span>
        </ShippingItem>
        <ShippingItem>
          <span>Postal Code:</span>
          <span>{address.zipcode}</span>
        </ShippingItem>
        <ShippingItem>
          <span>Country:</span>
          <span>{address.country}</span>
        </ShippingItem>
        <PackingItem>
          <span>Special Instructions:</span>
          <span>{packingInstructions}</span>
        </PackingItem>
      </ShippingBlock>
      <ShippingBlock>
        <Title>Billing</Title>
        <ShippingItem smallLabel>
          <span>PO Number:</span>
          <span>{poNumber}</span>
        </ShippingItem>
      </ShippingBlock>
    </ShippingInfoStyled>
  );
};

export { ShippingInfo };
